import { Injectable } from '@angular/core';
import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { PRODUCT_LINE_CODE } from '@ordersnproducts/modules/shared/constants/product-lines-codes';
import { Features } from '../models/features.enum';

@Injectable()
export class PurchaseOrderMaskValidationFeature implements IFlagFeature {
  name = Features.PurchaseOrderMaskValidation;

  protected enabledBusinessLines = {
    [PRODUCT_LINE_CODE.READY_MIX]: true,
  };

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled() && this.enabledBusinessLines[params.businessLine];
  }
}
